import { ref, computed } from 'vue';
import { useEventListener } from '@vueuse/core';

/**
 * Composable para escuchar el evento 'change' de la estructura y obtener su path,
 * idSeleccionado y tipo.
 * @param {*} selector Selector del elemento de la estructura o el propio elemento.
 * @returns {Object} Objeto con las propiedades path, idSeleccionado, tipo y pathComoParametros.
 */
export default function useEstructuraChangeEvent(selector) {
  const path = ref([]);
  const idSeleccionado = ref(null);
  const tipo = ref(null);

  const pathComoParametros = computed(() => {
    const params = {};
    path.value.forEach((nodo) => {
      params[`${nodo.type}_id`] = nodo.id;
    });
    return params;
  });

  const estructuraEl = computed(() => {
    if (typeof selector === 'string') return document.querySelector(selector);
    return selector;
  });

  useEventListener(estructuraEl, 'change', (event) => {
    path.value = event.detail?.path || [];
    idSeleccionado.value = event.detail?.idSeleccionado || null;
    tipo.value = event.detail?.tipo || null;
  });

  return {
    path, idSeleccionado, tipo, pathComoParametros,
  };
}
